/**
 * Locale trimmed to language enum
 */
export enum Language {
  ENGLISH = 'en',
  FRENCH = 'fr',
  SPANISH = 'es',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/common/src/i18n/index.ts